import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
import { Observable} from 'rxjs/Rx';
import 'rxjs/add/observable/interval';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { BlockExplorerService } from '../../services/blockExplorer.service';

@Component({
  selector: 'app-rm-layout',
  templateUrl: './rm-layout.component.html',
  styleUrls: ['./rm-layout.component.css']
})
export class RmLayoutComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  counterData: any;
  latestBlock: any;

  counterCount: any;
  activeNode: any;
  blockNumber: any;
  txnDetails: any;
  blkNumber: any;
  listOftxns: any;
  firstBlock: any;
  secondBlock: any;
  thirdBlock: any;
  constructor(public router: Router, public _httpService: BlockExplorerService) {
   // start calling your api every 10 secs
  //   Observable.timer(0, 10000)
  //   .subscribe(() => {
  //    this._httpService.OnGetContract().subscribe(
  //      data => {
  //         this.counterData = (data);
  //         console.log('counterData', this.counterData.total_no_of_chaincode);
  //         this.counterCount = this.counterData.total_no_of_chaincode;
  //      } ,
  //      error => {
  //       this.handleError(error);
  //     },
  //      () => console.log('list of invoices', this.counterData)
  //  );
  //   });

  //   Observable.timer(0, 10000)
  //   .subscribe(() => {
  //        this._httpService.OnGetLatestBlock().subscribe(
  //        data => {
  //          this.latestBlock = (data);
  //          console.log('dataVal', this.latestBlock.Latest_Block_Num );
  //          this.blockNumber = this.latestBlock.Latest_Block_Num ;
  //        } ,
  //        error => {
  //         this.handleError(error);
  //       },
  //        () => console.log('list of invoices', this.latestBlock)
  //    );
  //   });

  //   Observable.timer(0, 10000)
  //   .subscribe(() => {
  //      this._httpService.OnGetActiveNode().subscribe(
  //      data => {
  //        this.latestBlock = (data);
  //        console.log('dataVal', this.latestBlock.nodeCount);
  //        this.activeNode = this.latestBlock.nodeCount;
  //      } ,
  //      error => {
  //       this.handleError(error);
  //     },
  //      () => console.log('list of invoices', this.latestBlock)
  //    );
  //   });

  //   Observable.timer(0, 10000) // only fires when component is alive
  //   .subscribe(() => {
  //      this._httpService.OnGetAllTransactions().subscribe(
  //      data => {
  //        this.txnDetails = (data);
  //        console.log('txnDetails hash', this.txnDetails);
  //        const dataVal = this.txnDetails;
  //        console.log('dataVal', dataVal);
  //        this.firstBlock =  dataVal.first_block_hash;   
  //        this.secondBlock = dataVal.secod_block_hash;
  //        this.thirdBlock = dataVal.third_block_hash;
  //        this.listOftxns = dataVal;
  //        console.log( this.listOftxns);
  //      } ,
  //      error => {
  //       this.handleError(error);
  //     },
  //      () => console.log('txnDetails', this.txnDetails)
  //    );
  //   });
} 

  tabStatus = 'justified';

  public isCollapsed = false;

  public innerWidth: any;
  public defaultSidebar: any;
  public showSettings = false;
  public showMobileMenu = false;
  public expandLogo = false;

  options = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // fixed value. shouldn't be changed.
    sidebartype: 'iconbar', // four possible values: full, iconbar, overlay, mini-sidebar 
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin4', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin7', // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin4' // six possible values: skin(1/2/3/4/5/6)
  };

  Logo() {
    this.expandLogo = !this.expandLogo;
  }

  ngOnInit() {
    if (this.router.url === '/') {
      this.router.navigate(['/dashboard/dashboard1']);
    }
    this.defaultSidebar = this.options.sidebartype;
    this.handleSidebar();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.handleSidebar();
  }

  handleSidebar() {
    this.innerWidth = window.innerWidth;
    switch (this.defaultSidebar) {
      case 'full':
      case 'iconbar':
        if (this.innerWidth < 1170) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      case 'overlay':
        if (this.innerWidth < 767) {
          this.options.sidebartype = 'mini-sidebar';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default:
    }
  }

  toggleSidebarType() {
    switch (this.options.sidebartype) {
      case 'full':
      case 'iconbar':
        this.options.sidebartype = 'mini-sidebar';
        break;

      case 'overlay':
        this.showMobileMenu = !this.showMobileMenu;
        break;

      case 'mini-sidebar':
        if (this.defaultSidebar === 'mini-sidebar') {
          this.options.sidebartype = 'full';
        } else {
          this.options.sidebartype = this.defaultSidebar;
        }
        break;

      default: 
    }
  }
  handleError(error) {
    console.log('inside error');
  }

}

